/**
 * Joins class names, dropping anything falsy. Keeps conditional CSS Module
 * composition readable without pulling in a dependency.
 */
export const cn = (
  ...classes: Array<string | false | null | undefined>
): string => classes.filter(Boolean).join(' ')
